import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TicketStatus from "../../common/TicketStatus/TicketStatus";
import ChatSettingsToggler from "./ChatSettingsToggler/ChatSettingsToggler";
import HeaderInfo from "./HeaderInfo/HeaderInfo";
import { TICKETS_HEADER_ACTIONS } from "./enum";
import ChangeFormTicketModal from "./ChangeFormTicketModal/ChangeFormTicketModal";
import API from "services/lib/api";
import { apiRoute } from "services";
import { getErrorMessage } from "utils/helper";
import { ToastContext } from "components/dashboard/common/Toast/context/ToastContextProvider";
import {
    updateIncomingTicket,
    deleteIncomingTicket,
} from "store/tickets/incomingTickets/actions";
import { setActiveTicket } from "store/tickets/actions";
import { selectNextTicket } from "../../CustomerTicketsContainer/CustomerTickets/util/helper";
import SnoozeTicket from "../SnoozeTicket/SnoozeTicket";
import "./TicketsHeader.scss";

const {
    CLOSE_TICKET,
    SNOOZE_TICKET,
    CHANGE_FORM,
    MARK_TICKET_AS_READ,
} = TICKETS_HEADER_ACTIONS;

const TicketsHeader = ({
    selectedTicket,
    toggleTicketActionModal,
    handleSuccess,
    hideActions,
}) => {
    const { customer, ticketId, ticketPhase } = selectedTicket || {};
    const { email, appMessageUserId, userId, firstName } = customer || {};
    const { sortedTickets } = useSelector((state) => state.incomingTickets);
    const [showSnoozeTicketModal, setShowSnoozeTicketModal] = useState(false);
    const [showChangeFormModal, setShowChangeFormModal] = useState(false);
    const toastMessage = useContext(ToastContext);
    const dispatch = useDispatch();

    const markTicketAsRead = async () => {
        try {
            const url = apiRoute.resolveTicket(ticketId);
            const res = await API.put(url);

            if (res.status === 200) {
                const { message, data: updatedTicket } = res?.data || {};

                const serverTicket =
                    updatedTicket?.ticketId != null ? updatedTicket : null;
                dispatch(
                    updateIncomingTicket({
                        ...selectedTicket,
                        ...(serverTicket || { assigned: false }),
                        customer:
                            serverTicket?.customer ?? selectedTicket?.customer,
                    })
                );

                selectNextTicket(
                    selectedTicket,
                    sortedTickets,
                    (ticket, ticketId) => {
                        dispatch(setActiveTicket(ticket));
                        ticketId &&
                            dispatch(deleteIncomingTicket({ ticketId }));
                    }
                );
                toastMessage(message);
                handleSuccess?.();
            }
        } catch (err) {
            const message = getErrorMessage(err);
            toastMessage(message);
        }
    };

    const handleActionModal = (action) => {
        if (action === CLOSE_TICKET) {
            toggleTicketActionModal?.(selectedTicket, action);
        } else if (action === SNOOZE_TICKET) {
            setShowSnoozeTicketModal(true);
        } else if (action === CHANGE_FORM) {
            setShowChangeFormModal(true);
        } else if (action === MARK_TICKET_AS_READ) {
            markTicketAsRead();
        }
    };

    return (
        <div id='ticketsHeader' className='tickets__header'>
            <div className='header__rows'>
                <div className='user__names'>
                    {firstName && (
                        <span className='user__name'>{firstName}</span>
                    )}
                    <h6>{email || appMessageUserId || userId}</h6>
                </div>
                <HeaderInfo otherClassName={"ms-auto"}>
                    <TicketStatus key={ticketId} {...{ ticketId, ticketPhase }} />
                </HeaderInfo>
                {!hideActions && (
                    <ChatSettingsToggler
                        handleActionModal={handleActionModal}
                        ticketPhase={ticketPhase}
                    />
                )}
            </div>
            {showSnoozeTicketModal && (
                <SnoozeTicket
                    show={showSnoozeTicketModal}
                    closeModal={() => setShowSnoozeTicketModal(false)}
                    handleSuccess={handleSuccess}
                    referenceTicket={selectedTicket}
                />
            )}
            {showChangeFormModal && (
                <ChangeFormTicketModal
                    show={showChangeFormModal}
                    closeModal={() => setShowChangeFormModal(false)}
                    selectedTicket={selectedTicket}
                />
            )}
        </div>
    );
};

export default TicketsHeader;
